import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import defaultImg from './../../../images/task/img1.jpg';
import { var_api, image_api } from '../../../constant';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const VariantMaster = () => {
  const tableHeaders = ["#", "Image", "Variant ", "Code", "UOM", "Gross/Net", "Qty Count", "Status", "Action"];
  const [variantData, setVariantData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [file, setFile] = useState(null);
  const [uomData, setUomData] = useState([]);
   const [productName, setProductName] = useState("");

  const [formData, setFormData] = useState({
    cat_id: localStorage.getItem("veemart_cat_id") || "",
    product_id: localStorage.getItem("product_id") || "",
    veemart_variant_code: "",
    variant_name: "",
    variant_image: "",
    description: "",
    uom: "",
    gross_weight: "",
    net_weight: "",
    qty_count: "",
    additional_note: "",
    active_status: 1,
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [initialLoading, setInitialLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchVariantData();
    fetchUomData();
      const storedName = localStorage.getItem("name");
    if (storedName) {
      setProductName(storedName);
    }
  }, []);

  const fetchVariantData = async () => {
    try {
      setInitialLoading(true);
      const res = await axios.get(`${var_api}sa_veemart_variant_master/get`);
      const allData = res.data || [];

      const productId = localStorage.getItem("product_id");
      if (productId) {
        const filtered = allData.filter(v => String(v.product_id) === String(productId));
        setVariantData(filtered);
      } else {
        setVariantData(allData);
      }
    } catch (err) {
      toast.error("Failed to fetch data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchUomData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_uom_master/get`);
      setUomData(res.data || []);
    } catch (err) {
      console.error("Failed to fetch UOM data", err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const handleAddClick = () => {
    setFormData({
      cat_id: localStorage.getItem("veemart_cat_id") || "",
      product_id: localStorage.getItem("product_id") || "",
      veemart_variant_code: "",
      variant_name: "",
      variant_image: "",
      description: "",
      uom: "",
      gross_weight: "",
      net_weight: "",
      qty_count: "",
      additional_note: "",
      active_status: 1,
    });
    setFile(null);
    setErrors({});
    setIsEditMode(false);
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setFile(null);
    setIsEditMode(true);
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.variant_name.trim()) newErrors.variant_name = "Variant name is required";
    if (!formData.veemart_variant_code.trim()) newErrors.veemart_variant_code = "Variant code is required";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);
      const form = new FormData();
      Object.entries(formData).forEach(([key, value]) => form.append(key, value));
      if (file) form.append("variant_image", file);

      const headers = { headers: { "Content-Type": "multipart/form-data" } };
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}sa_veemart_variant_master/update/${formData.id}`, form, headers);
      } else {
        res = await axios.post(`${var_api}sa_veemart_variant_master/post`, form, headers);
      }

      toast.success(res?.data?.message || "Saved successfully");
      setShowModal(false);
      fetchVariantData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Error saving data");
    } finally {
      setLoading(false);
    }
  };

  const filteredData = variantData.filter(item =>
    Object.values(item).some(val => String(val).toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          <div className="d-flex align-items-center gap-2 mb-3">
            <Button variant="light" onClick={() => navigate(-1)} className="shadow-sm">
              <i className="fas fa-arrow-left"></i>
            </Button>
               <h5>
        Product Variants for:{" "}
        <span style={{ color: "blue" }}>{productName}</span>
      </h5>
          </div>

          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search variant..."
                  value={searchQuery}
                  onChange={e => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>Add</Button>
              </div>

              <div className="table-responsive">
                <table className="table ">
                  <thead>
                    <tr>{tableHeaders.map((header, i) => <th key={i}>{header}</th>)}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="9" className="text-center text-muted py-3">No data found</td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>
                            <img
                              src={item.variant_image ? `${image_api}${item.variant_image.replace(/^test\//, '')}` : defaultImg}
                              alt="variant"
                              width="40"
                              height="40"
                              className="rounded"
                            />
                          </td>
                          <td>{item.variant_name}</td>
                          <td>{item.veemart_variant_code}</td>
                          <td>{item.uom}</td>
                          <td>{item.gross_weight}/{item.net_weight}</td>
                          <td>{item.qty_count}</td>
                          <td>
                            <span className={`badge ${item.active_status === 1 ? "bg-success" : "bg-danger"}`}>
                              {item.active_status === 1 ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td>
                            <Link
                              to="#"
                              className="btn shadow btn-xs sharp me-1"
                              style={{ backgroundColor: "#007bff", color: "white" }}
                              onClick={() => handleEditClick(item)}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-end mt-3">
                {[...Array(totalPages)].map((_, idx) => (
                  <Button
                    key={idx}
                    variant={currentPage === idx + 1 ? "primary" : "light"}
                    onClick={() => setCurrentPage(idx + 1)}
                    className="me-1"
                  >
                    {idx + 1}
                  </Button>
                ))}
              </div>
            </>
          )}
        </Card.Body>

        {/* Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Variant" : "Add Variant"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Variant  <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="variant_name"
                      value={formData.variant_name}
                      placeholder="Enter variant name"
                      onChange={handleInputChange}
                    />
                    {errors.variant_name && <div className="text-danger small">{errors.variant_name}</div>}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Variant Code <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="veemart_variant_code"
                      value={formData.veemart_variant_code}
                      placeholder="Enter code"
                      onChange={handleInputChange}
                    />
                    {errors.veemart_variant_code && <div className="text-danger small">{errors.veemart_variant_code}</div>}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>UOM</Form.Label>
                    <Form.Select name="uom" value={formData.uom} onChange={handleInputChange}>
                      <option value="">-- Select UOM --</option>
                      {uomData.map((u) => (
                        <option key={u.uom_name} value={u.uom_name}>
                          {u.uom_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Gross Weight</Form.Label>
                    <Form.Control
                      type="text"
                      name="gross_weight"
                      value={formData.gross_weight}
                      onChange={handleInputChange}
                      placeholder="Enter gross weight"
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Net Weight</Form.Label>
                    <Form.Control
                      type="text"
                      name="net_weight"
                      value={formData.net_weight}
                      onChange={handleInputChange}
                      placeholder="Enter net weight"
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Qty Count</Form.Label>
                    <Form.Control
                      type="number"
                      name="qty_count"
                      value={formData.qty_count}
                      onChange={handleInputChange}
                      placeholder="Enter quantity count"
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Additional Note</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="additional_note"
                      rows={2}
                      value={formData.additional_note}
                      onChange={handleInputChange}
                      placeholder="Enter additional note"
                    />
                  </Form.Group>
                </Col>

                     {isEditMode && (
                                <Col md={6}>
                                  <Form.Group className="mb-2 d-flex align-items-center gap-2">
                                    <Form.Label className="mb-0">
                                      {formData.active_status === 1 ? "Active" : "Inactive"}
                                    </Form.Label>
                                    <Form.Check
                                      type="switch"
                                      id="active-status"
                                      checked={formData.active_status === 1}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          active_status: e.target.checked ? 1 : 0,
                                        })
                                      }
                                      className={`custom-switch ${formData.active_status === 1
                                          ? "switch-success"
                                          : "switch-danger"
                                        }`}
                                    />
                                  </Form.Group>
                                </Col>
                              )}

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Variant Image</Form.Label>
                    {isEditMode && formData.variant_image && !file && (
                      <div className="mb-2">
                        <img
                          src={`${image_api}${formData.variant_image.replace(/^test\//, '')}`}
                          alt="Preview"
                          width="80"
                          className="rounded border"
                        />
                      </div>
                    )}
                    <Form.Control type="file" accept="image/*" onChange={(e) => setFile(e.target.files[0])} />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <ReactQuill
                      theme="snow"
                      value={formData.description}
                      onChange={(value) => setFormData(prev => ({ ...prev, description: value }))}
                      placeholder="Enter description"
                    />
                  </Form.Group>
                </Col>
              </Row>

                         <div className="d-flex justify-content-end gap-2">
                          {isEditMode ? (
                            <>
                              {/* ✅ Update button */}
                              <Button
                                variant="warning"
                                type="submit"
                                disabled={loading}
                              >
                                {loading ? "Updating..." : "Update"}
                              </Button>
                        
                              {/* ✅ Cancel button */}
                              <Button
                                variant="danger"
                                onClick={() => setShowModal(false)}
                              >
                                Cancel
                              </Button>
                            </>
                          ) : (
                            <>
                              {/* ✅ Create button */}
                              <Button
                                variant="secondary"
                                type="submit"
                                disabled={loading}
                              >
                                {loading ? "Creating..." : "Create"}
                              </Button>
                        
                              {/* ✅ Reset button */}
                              <Button
                                variant="danger"
                                onClick={() =>
                                  setFormData({
                                      cat_id: localStorage.getItem("veemart_cat_id") || "",
      product_id: localStorage.getItem("product_id") || "",
      veemart_variant_code: "",
      variant_name: "",
      variant_image: "",
      description: "",
      uom: "",
      gross_weight: "",
      net_weight: "",
      qty_count: "",
      additional_note: "",
      active_status: 1,
                        
                                  })
                                }
                              >
                                Reset
                              </Button>
                            </>
                          )}
                        </div>
            </Form>
          </Modal.Body>
        </Modal>
      </Card>

      <ToastContainer />
    </>
  );
};

export default VariantMaster;
